import React, { useRef } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./CustomTab.css";

function CustomTabs({ data = [], selectedData, setSelectedData }) {
  const scrollRef = useRef();

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -150, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 150, behavior: "smooth" });
  };

  const visibleData = data.slice(0, 20); // show max 20 tabs
  const visibleIds = visibleData.map((item) => item.id);
  const activeId = visibleIds.includes(selectedData?.id)
    ? selectedData.id
    : visibleIds[0] ?? null;

  return (
    <div className="tabs-wrapper">
      <div className="tabs-container">
        <button className="scroll-btn left" onClick={scrollLeft}>
          <ArrowBackIosNewIcon fontSize="small" />
        </button>

        <div className="tabs-scroll-area" ref={scrollRef}>
          {visibleData.map((item) => (
            <button
              key={item.id}
              className={`tab-btn ${activeId === item.id ? "active" : ""}`}
              onClick={() => setSelectedData(item)}
            >
              {item.title}
            </button>
          ))}
        </div>

        <button className="scroll-btn right" onClick={scrollRight}>
          <ArrowForwardIosIcon fontSize="small" />
        </button>
      </div>
    </div>
  );
}

export default CustomTabs;
